export const QUERY_TYPES = [
  'Missing Required Information',
  'Missing Imaging Data',
  'Incomplete Image Series',
  'Low Image Quality',
  'Incorrect Imaging Modality',
  'Inconsistent Image Acquisition Parameters',
  'Incorrect Anatomy Uploaded',
  'Incorrect Visit Assignment',
  'Incorrect Subject Assignment',
  'Incorrect Date of Birth',
  'Subject Identification Issues',
  'DICOM Metadata Issues',
  'Incorrect Image Orientation',
];
